import { styled } from "../../../styles";

export const ModalBodyText = styled("p", {
  fontFamily: "$openSans",
  fontSize: "14px",
  color: "$charcoal",
  margin: 0,

  "& strong": {
    fontWeight: 700,
  },
});
